module.exports = __webpack_public_path__ + "static/media/vaccine_slider_phone1.2c451f79.png";